"use strict";

angular.module("customer")
.constant("REFRESH_HOME_VENDOR_LISTING_MESSAGE_NAME", "refreshHomeVendorsListing");



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/vendors-list/vendor-list.constants.js
// module id = 887
// module chunks = 0